<template>
  <div id="itf-operator-panel">
    <template v-if="add || edit">
      <ItfForm @saved="onSaved" @cancel="onCancelForm" />
    </template>

    <template v-else-if="docs.print">
      <ItfPrint @closed="onPrintClosed" />
    </template>

    <template v-else>
      <ItfListGrid ref="listGrid" action-name="getItfs" />
    </template>
  </div>
</template>

<script>
import store from '@/store'
import itfModule from '@/store/itf/itf'
import ItfForm from '@/views/pages/itf/ItfForm.vue'
import ItfPrint from '@/views/pages/itf/docs/ItfPrint.vue'
import ItfListGrid from '@/views/pages/itf/ItfListGrid.vue'

export default {
  name: 'ItfOperatorPanel',
  components: {
    ItfForm,
    ItfPrint,
    ItfListGrid,
  },
  data() {
    return {
      ITF_STORE_MODULE_NAME: 'itfModule',
    }
  },
  computed: {
    add() {
      return this.$store.state[this.ITF_STORE_MODULE_NAME].add
    },
    edit() {
      return this.$store.state[this.ITF_STORE_MODULE_NAME].edit
    },
    docs() {
      return this.$store.state[this.ITF_STORE_MODULE_NAME].docs
    },
  },
  created() {
    if (!store.hasModule(this.ITF_STORE_MODULE_NAME)) {
      store.registerModule(this.ITF_STORE_MODULE_NAME, itfModule)
    }
  },
  methods: {
    refreshList() {
      if (this.$refs.listGrid) {
        this.$refs.listGrid.reload()
      }
    },
    onSaved() {
      this.$nextTick(() => this.refreshList())
    },
    onCancelForm() {
      this.$nextTick(() => this.refreshList())
    },
    onPrintClosed() {
      this.$nextTick(() => this.refreshList())
    },
  },
}
</script>
